import { createFileRoute, Outlet } from '@tanstack/react-router'
import z from 'zod'
import AppNavigationShell from '@/components/organisms/app-navigation-shell'
import { useRealtimeTimeEntriesSync } from '@/hooks/useRealtimeTimeEntriesSync'
import { useRealtimeWorkflowSync } from '@/hooks/useRealtimeWorkflowSync'
import { useWorkshopUrlSync } from '@/hooks/useWorkshopUrlSync'
import { SettingsActions } from '@/redux/reducers/settings'
import { makeStore } from '@/redux/store'

const searchSchema = z.object({
  workshop: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated')({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    if (search.workshop !== undefined) {
      makeStore().dispatch(SettingsActions.setActiveWorkshopId(search.workshop))
    }
  },
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  useWorkshopUrlSync()
  useRealtimeWorkflowSync()
  useRealtimeTimeEntriesSync()

  return (
    <AppNavigationShell>
      <Outlet />
    </AppNavigationShell>
  )
}
